/* Extraído de index.jsx (refatoração 4.5) — constantes e funções puras.
   Código movido VERBATIM, sem mudança de lógica. */
/* ─── Definição dos serviços por gênero ─── */
export const SERVICES = [
  /* ── Femininos ── */
  {
    id:     'consulta_feminina',
    label:  'Consulta Nutricional Feminina',
    desc:   'Avaliação completa com foco na saúde da mulher',
    color:  '#D4A574', bg: '#fbf8f5', icon: '📋', gender: 'female',
  },
  {
    id:     'emagrecimento_feminino',
    label:  'Programa de Emagrecimento Feminino',
    desc:   'Metabolismo, controle da fome, sem efeito sanfona',
    color:  '#c46a60', bg: '#f8ebe9', icon: '🔥', gender: 'female',
  },
  {
    id:     'equilibrio_hormonal',
    label:  'Nutrição para Equilíbrio Hormonal',
    desc:   'SOP, TPM, menopausa, retenção de líquidos, cansaço crônico',
    color:  '#7189a6', bg: '#f6f0ea', icon: '⚡', gender: 'female',
  },
  {
    id:     'mulheres_ativas',
    label:  'Nutrição para Mulheres Ativas',
    desc:   'Desempenho físico, ganho de massa magra, energia para treino',
    color:  '#4f6a86', bg: '#edf1f6', icon: '💪', gender: 'female',
  },
  {
    id:     'reeducacao_alimentar',
    label:  'Reeducação Alimentar e Controle da Compulsão',
    desc:   'Fome emocional, ansiedade, comportamento alimentar',
    color:  '#46714f', bg: '#edf4ee', icon: '🌱', gender: 'female',
  },
  {
    id:     'planejamento_especializado',
    label:  'Planejamento Alimentar Especializado',
    desc:   'Low Carb, Keto, Anti-inflamatória, Vegetariana/Vegana',
    color:  '#c4933f', bg: '#f6f0ea', icon: '🎯', gender: 'female',
  },
  {
    id:     'acompanhamento_continuo',
    label:  'Acompanhamento Nutricional Contínuo',
    desc:   'Revisão de plano existente, ajustes conforme evolução',
    color:  '#736b64', bg: '#f6f0ea', icon: '🔄', gender: 'female',
  },
  /* ── Masculinos ── */
  {
    id:     'consulta_masculina',
    label:  'Consulta Nutricional Masculina',
    desc:   'Avaliação completa com foco na saúde do homem',
    color:  '#4f6a86', bg: '#edf1f6', icon: '📋', gender: 'male',
  },
  {
    id:     'hipertrofia_massa',
    label:  'Hipertrofia e Ganho de Massa Muscular',
    desc:   'Aumento de massa, ingestão proteica otimizada, periodização',
    color:  '#7189a6', bg: '#edf1f6', icon: '💪', gender: 'male',
  },
  {
    id:     'emagrecimento_masculino',
    label:  'Programa de Emagrecimento Masculino',
    desc:   'Queima de gordura preservando massa magra',
    color:  '#c46a60', bg: '#f8ebe9', icon: '🔥', gender: 'male',
  },
  {
    id:     'performance_esportiva',
    label:  'Performance Esportiva e Resistência',
    desc:   'Energia para treinos intensos, recuperação muscular, suplementação',
    color:  '#2f5236', bg: '#edf4ee', icon: '⚡', gender: 'male',
  },
  {
    id:     'saude_cardiovascular',
    label:  'Saúde Cardiovascular e Colesterol',
    desc:   'Controle de LDL, triglicerídeos, pressão e saúde cardíaca',
    color:  '#8a5f1a', bg: '#fbf8f5', icon: '❤️', gender: 'male',
  },
  {
    id:     'saude_metabolica',
    label:  'Saúde Metabólica e Controle Glicêmico',
    desc:   'Resistência insulínica, diabetes tipo 2, síndrome metabólica',
    color:  '#7189a6', bg: '#edf1f6', icon: '🩺', gender: 'male',
  },
  {
    id:     'acompanhamento_continuo',
    label:  'Acompanhamento Nutricional Contínuo',
    desc:   'Revisão de plano existente, ajustes conforme evolução',
    color:  '#736b64', bg: '#f6f0ea', icon: '🔄', gender: 'male',
  },
  /* Programas válidos para os dois sexos (backend: programas-nutricionais.php) */
  {
    id:     'saude_cardiovascular',
    label:  'Saúde Cardiovascular e Colesterol',
    desc:   'Controle de LDL, triglicerídeos, pressão e saúde cardíaca',
    color:  '#8a5f1a', bg: '#fbf8f5', icon: '❤️', gender: 'female',
  },
  {
    id:     'saude_metabolica',
    label:  'Saúde Metabólica e Controle Glicêmico',
    desc:   'Resistência insulínica, diabetes tipo 2, síndrome metabólica',
    color:  '#7189a6', bg: '#edf1f6', icon: '🩺', gender: 'female',
  },
  {
    id:     'reeducacao_alimentar',
    label:  'Reeducação Alimentar e Controle da Compulsão',
    desc:   'Fome emocional, ansiedade, comportamento alimentar',
    color:  '#46714f', bg: '#edf4ee', icon: '🌱', gender: 'male',
  },
  {
    id:     'planejamento_especializado',
    label:  'Planejamento Alimentar Especializado',
    desc:   'Low Carb, Keto, Anti-inflamatória, Vegetariana/Vegana',
    color:  '#c4933f', bg: '#f6f0ea', icon: '🎯', gender: 'male',
  },
];

export const STRATEGIES = [
  { id: 'low_carb',           label: 'Low Carb',               icon: '🥩' },
  { id: 'cetogenica',         label: 'Cetogênica (Keto)',       icon: '🥑' },
  { id: 'anti_inflamatoria',  label: 'Anti-inflamatória',      icon: '🫚' },
  { id: 'vegetariana',        label: 'Vegetariana',            icon: '🥚' },
  { id: 'vegana',             label: 'Vegana',                 icon: '🌿' },
];

export const serviceById  = (id) => SERVICES.find(s => s.id === id) || SERVICES[0];
export const uniqueServices = (list) => {
  const seen = new Set();
  return list.filter(s => { const key = s.id + s.gender; if (seen.has(key)) return false; seen.add(key); return true; });
};
export const strategyById = (id) => STRATEGIES.find(s => s.id === id);

/* ─── Refeições ─── */
// Ordem padrão (planos antigos, sem `ordem` nas refeições) — as 6 clássicas
export const MEAL_ORDER = ['cafe_manha', 'lanche_manha', 'almoco', 'lanche_tarde', 'jantar', 'ceia'];
// Ordem canônica completa (inclui pré/pós-treino); chaves livres (extra_N) vão ao final
export const MEAL_ORDER_FULL = ['cafe_manha', 'lanche_manha', 'almoco', 'lanche_tarde', 'pre_treino', 'pos_treino', 'jantar', 'ceia'];
export const MEAL_ICONS = { cafe_manha:'☕', lanche_manha:'🍎', almoco:'🍽️', lanche_tarde:'🥪', pre_treino:'⚡', pos_treino:'💪', jantar:'🌙', ceia:'🫖' };
export const MEAL_NAMES = {
  cafe_manha: 'Café da manhã', lanche_manha: 'Lanche da manhã', almoco: 'Almoço', lanche_tarde: 'Lanche da tarde',
  pre_treino: 'Pré-treino', pos_treino: 'Pós-treino', jantar: 'Jantar', ceia: 'Ceia',
};
export const mealIcon = (key) => MEAL_ICONS[key] || '🍴';
export const nomeRefeicao = (key, meal) => (meal && meal.nome) || MEAL_NAMES[key] || key;

/**
 * Fonte ÚNICA da ordem das refeições: [chave, refeição][] ordenado por
 * `ordem` (definida pela nutricionista); sem `ordem`, pela ordem canônica;
 * chaves desconhecidas ao final, na ordem em que aparecem. Refeições que não
 * são objeto (formatos antigos) são ignoradas, como antes.
 */
export function ordenarRefeicoes(meals) {
  if (!meals || typeof meals !== 'object') return [];
  const pos = (k, m, i) => {
    const o = Number(m?.ordem);
    if (Number.isFinite(o) && o > 0) return o;
    const c = MEAL_ORDER_FULL.indexOf(k);
    return c >= 0 ? c + 1 : 1000 + i;
  };
  return Object.entries(meals)
    .map(([k, m], i) => [k, m, pos(k, m, i)])
    .filter(([, m]) => m && typeof m === 'object' && !Array.isArray(m))
    .sort((a, b) => a[2] - b[2])
    .map(([k, m]) => [k, m]);
}

/* ─── helpers ─── */
export const sum   = (arr, key) => arr.reduce((t, x) => t + (parseFloat(x[key]) || 0), 0);
export const fmt1  = (n) => (parseFloat(n) || 0).toFixed(1);
export const empty = () => ({ alimento:'', porcao:'', calorias:0, proteina:0, carboidratos:0, gordura:0 });

export function dayTotals(meals) {
  // Soma sempre a partir dos ALIMENTOS (fonte única da verdade), nunca dos
  // totais por refeição — assim a tela bate com o PDF mesmo em planos antigos.
  return Object.values(meals || {}).reduce((t, m) => {
    const foods = m.alimentos || [];
    return {
      cal:  t.cal  + foods.reduce((s, a) => s + (parseFloat(a.calorias)     || 0), 0),
      prot: t.prot + foods.reduce((s, a) => s + (parseFloat(a.proteina)     || 0), 0),
      carb: t.carb + foods.reduce((s, a) => s + (parseFloat(a.carboidratos) || 0), 0),
      fat:  t.fat  + foods.reduce((s, a) => s + (parseFloat(a.gordura)      || 0), 0),
    };
  }, { cal:0, prot:0, carb:0, fat:0 });
}

/* ── Guess food category from name (for substitutes) ── */
export function guessCategory(name) {
  if (!name) return null;
  const n = name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  if (/frango|peito|carne|peixe|atum|camara|sardinha|salmao|tilapia|suina|bovina|bife|file|peru/.test(n)) return 'Proteínas Animais';
  if (/tofu|tempeh|grao.?de.?bico|lentilha|feijao|soja|edamame|seitan/.test(n)) return 'Proteínas Vegetais';
  if (/batata.doce/.test(n)) return 'Cereais e Carboidratos';
  if (/arroz|macarra|batata|inhame|cuscuz|tapioca|aveia|quinoa|pao|mandioca|polenta|granola/.test(n)) return 'Cereais e Carboidratos';
  if (/brocolis|couve.flor|abobrinha|cenoura|beterraba|chuchu|quiabo|berinjela|vagem|pepino|tomate|alface|rucula|espinafre|couve|cebola|alho|abobora|milho|ervilha/.test(n)) return 'Legumes e Verduras';
  if (/banana|maca|laranja|mamao|abacate|morango|melao|abacaxi|uva|pera|manga|kiwi|melancia|maracuja|goiaba/.test(n)) return 'Frutas';
  if (/leite|iogurte|queijo|ricota|cottage|kefir|whey/.test(n)) return 'Laticínios';
  if (/azeite|amendoim|castanha|amendoa|noz|chia|linhaca|coco|manteiga|oliva|gergelim|pasta/.test(n)) return 'Gorduras Boas';
  if (/feijao|lentilha|grao|ervilha|fradinho/.test(n)) return 'Leguminosas';
  return null;
}

/* ── Get substitutes from food array ── */
export function getSubstitutes(foodName, foodCal, portionStr, allFoodsArr) {
  const category = guessCategory(foodName);
  if (!category || allFoodsArr.length === 0) return [];

  const portionMatch = String(portionStr || '').match(/(\d+(?:\.\d+)?)\s*g/);
  const portionGrams = portionMatch ? parseFloat(portionMatch[1]) : 100;
  const calPer100g   = portionGrams > 0 ? (foodCal / portionGrams) * 100 : null;

  return allFoodsArr
    .filter(f => f.categoria === category && f.nome.toLowerCase() !== foodName.toLowerCase())
    .map(f => {
      const eqPortion = calPer100g && f.calorias_100g > 0
        ? Math.max(30, Math.round((foodCal / f.calorias_100g) * 100 / 5) * 5)
        : (f.porcao_padrao || 100);
      const factor  = eqPortion / 100;
      const eqCal   = Math.round(f.calorias_100g * factor);
      const calDiff = eqCal - Math.round(foodCal);
      return { ...f, eqPortion, eqCal, eqProt: parseFloat((f.proteina_100g * factor).toFixed(1)),
        eqCarb: parseFloat((f.carbo_100g * factor).toFixed(1)),
        eqFat:  parseFloat((f.gordura_100g * factor).toFixed(1)), calDiff };
    })
    .sort((a, b) => Math.abs(a.calDiff) - Math.abs(b.calDiff))
    .slice(0, 5);
}

